webpackJsonp([54],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download


function download(data, strFileName, strMimeType, headers, finishCb) {

  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    // if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = 'blob';
    for (var _i in headers) {
      if (headers.hasOwnProperty(_i)) {
        ajax.setRequestHeader(_i, headers[_i]);
      }
      // }
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime, headers, finishCb);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?


  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
      navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
        if (finishCb) {
          finishCb();
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver


  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),

/***/ 1566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basicInfoFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return payInfoformRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reviewInfoformRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return writeOffFormRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的付款管理ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {};

var basicInfoFormRules = {
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择付款类型', 'integer'))],
  payment_company: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择付款公司', 'integer'))],
  expected_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('付款加急时需选择期望日期', 'string'))],
  desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('付款说明不能为空', 'string'))]
};

var payInfoformRules = {
  company_name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置收款对象名称', 'string'))],
  bank_account: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入银行账号', 'string'))],
  bank: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入开户银行支行', 'string'))],
  bank_headquarters: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入开户银行总行', 'string'))]
};

var reviewInfoformRules = {
  department_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置部门领导审批', 'integer'))],
  first_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置一级审批', 'integer'))],
  second_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置二级审批', 'integer'))],
  third_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置三级审批', 'integer'))],
  fourth_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请设置四级审批', 'integer'))]
};

var writeOffFormRules = {
  // amount: [
  //   {...makeRule('请输入冲销金额', 'string')},
  // ],
  // invoice_type: [
  //   {...makeRule('请选择发票类型', 'integer')},
  // ],
  // tax_rate: [
  //   {...makeRule('请选择税率', 'integer')},
  // ],
};

/***/ }),

/***/ 1661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exportHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportDetailHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return exportWriteOffDetailHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return exportWriteOffStatusHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return exportSearchAggregateheader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defalutValueSummary; });
var exportHeader = [{ key: 'payment_company', text: '付款公司' }, { key: 'payment_company_account', text: '付款账户/银行账号' }, { key: 'id', text: '付款ID' }, { key: 'status', text: '付款状态' }, { key: 'applicant_name', text: '申请人' }, { key: 'department_name', text: '申请人部门' }, { key: 'type', text: '付款类型' }, { key: 'desc', text: '付款说明' }, { key: 'expected_date', text: '加急付款日期' }, { key: 'receipt_name', text: '收款方名称' }, { key: 'bank_account', text: '银行账号' }, { key: 'bank', text: '开户银行支行' }, { key: 'bank_headquarters', text: '开户银行总行' }, { key: 'apply_amount', text: '应付金额' }, { key: 'paid_amount_total', text: '实付金额' }, { key: 'paid_date', text: '付款日期' }];

var exportDetailHeader = [{ key: 'payment_company', text: '付款公司' }, { key: 'payment_company_account', text: '付款账户/银行账号' }, { key: 'id', text: '付款ID' }, { key: 'applicant_name', text: '申请人' }, { key: 'department_name', text: '申请人部门' }, { key: 'type', text: '付款类型' }, { key: 'desc', text: '付款说明' }, { key: 'status', text: '付款状态' }, { key: 'detail_paid_amount', text: '实付金额' }, { key: 'detail_paid_no_tax_amount', text: '未税实付金额' }, { key: 'detail_project_name', text: '项目名称' }, { key: 'detail_project_number', text: '项目编号' }, { key: 'detail_department_name', text: '费用承担部门' }, { key: 'detail_first_subject', text: '一级科目' }, { key: 'detail_second_subject', text: '二级科目' }, { key: 'detail_invoice_type', text: '发票类型' }, { key: 'detail_tax_rate', text: '税率' }, { key: 'detail_apply_amount', text: '应付金额' }, { key: 'paid_date', text: '付款日期' }, { key: 'paid_to_type_name', text: '付款主体' }, { key: 'receipt_id', text: '收款方ID' }, { key: 'receipt_name', text: '收款方名称' }, { key: 'bank_account', text: '银行账号' }, { key: 'bank', text: '开户银行支行' }, { key: 'bank_headquarters', text: '开户银行总行' }, { key: 'detail_desc', text: '摘要' }];

var exportWriteOffDetailHeader = [{ key: 'payment_company', text: '付款公司' }, { key: 'id', text: '付款ID' }, { key: 'applicant_name', text: '申请人' }, { key: 'department_name', text: '申请人部门' }, { key: 'type', text: '付款类型' }, { key: 'desc', text: '付款说明' }, { key: 'status', text: '付款状态' }, { key: 'paid_to_type_name', text: '付款主体' }, { key: 'receipt_id', text: '收款方ID' }, { key: 'receipt_name', text: '收款方名称' }, { key: 'detail_project_name', text: '项目名称' }, { key: 'detail_project_number', text: '项目编号' }, { key: 'detail_department_name', text: '费用承担部门' }, { key: 'detail_first_subject', text: '一级科目' }, { key: 'detail_second_subject', text: '二级科目' }, { key: 'detail_invoice_type', text: '发票类型' }, { key: 'detail_tax_rate', text: '税率' }, { key: 'detail_amount_with_taxed', text: '含税冲销金额' }, { key: 'detail_amount_untaxed', text: '未税冲销金额' }, { key: 'detail_write_off_at', text: '冲销日期' }, { key: 'detail_desc', text: '摘要' }];

var exportWriteOffStatusHeader = [{ key: 'payment_company', text: '付款公司' }, { key: 'id', text: '付款ID' }, { key: 'applicant_name', text: '申请人' }, { key: 'department_name', text: '申请人部门' }, { key: 'type', text: '付款类型' }, { key: 'desc', text: '付款说明' }, { key: 'paid_to_type_name', text: '付款主体' }, { key: 'receipt_id', text: '收款方ID' }, { key: 'receipt_name', text: '收款方名称' }, { key: 'paid_amount_total', text: '实付金额' }, { key: 'written_off_amount', text: '已冲销金额' }, { key: 'wait_write_off', text: '未冲销金额' }, { key: 'status', text: '付款状态' }, { key: 'write_off_status_txt', text: '冲销状态' }, { key: 'export_at', text: '导出时间' }];

var exportSearchAggregateheader = [{ key: 'name', text: '状态' }, { key: 'apply_total', text: '应付金额' }, { key: 'paid_total', text: '实付金额' }];

var defalutValueSummary = {
  5: { apply_total: 0, paid_total: 0, name: '待会计审批' },
  6: { apply_total: 0, paid_total: 0, name: '待财务经理审批' },
  7: { apply_total: 0, paid_total: 0, name: '待付款' },
  other: { apply_total: 0, paid_total: 0, name: '其他' },
  paid: { apply_total: 0, paid_total: 0, name: '已付款' },
  pending: { apply_total: 0, paid_total: 0, name: '待审批' },
  summary: { apply_total: 0, paid_total: 0, name: '总计' }
};

/***/ }),

/***/ 1795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkReviewPermissionWithUser;
function checkReviewPermissionWithUser(row, user) {
  if ([1, 2, 3, 4, 13, 14].includes(row.status)) {
    // 待各级审批
    if (user.usertype * 1 === 1) {
      // 超管
      return true;
    } else {
      // 各级审批人
      var userId = user.id * 1;
      if (row.status === 1) {
        return row.first_approver * 1 === userId;
      } else if (row.status === 2) {
        return row.second_approver * 1 === userId;
      } else if (row.status === 3) {
        return row.third_approver * 1 === userId;
      } else if (row.status === 4) {
        return row.fourth_approver * 1 === userId;
      } else if (row.status === 13) {
        return row.department_approver * 1 === userId;
      } else if (row.status === 14) {
        return row.special_approver * 1 === userId;
      }
    }
  } else {
    return false;
  }
}

/***/ }),

/***/ 2041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: Boolean,
    title: String,
    data: Array
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 2401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__ = __webpack_require__(1661);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      exportHeader: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["c" /* exportHeader */],
      exportDetailHeader: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["b" /* exportDetailHeader */],
      exportWriteOffDetailHeader: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["e" /* exportWriteOffDetailHeader */],
      exportWriteOffStatusHeader: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["f" /* exportWriteOffStatusHeader */],
      exportSearchAggregateheader: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["d" /* exportSearchAggregateheader */],
      defalutValueSummary: __WEBPACK_IMPORTED_MODULE_4__views_payment_manager_components_payment_manager_export_header_js__["a" /* defalutValueSummary */]
    };
  },

  methods: {
    exportDetailTableData: function exportDetailTableData(params) {
      return request.page('exportDetailTableData', params);
    },
    exportWriteOffDetailTableData: function exportWriteOffDetailTableData(params) {
      return request.page('exportWriteOffDetailTableData', params);
    },
    exportWriteOffStatusDataRequest: function exportWriteOffStatusDataRequest(params) {
      return request.page('exportWriteOffStatusData', params);
    },
    exportExportSearchAggregateData: function exportExportSearchAggregateData(params) {
      return request.page('exportExportSearchAggregateData', params);
    },


    // 按照财务格式导出
    onExportFinanceSearch: function onExportFinanceSearch() {
      var _this = this;

      this.$export('付款列表财务格式导出', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.exportTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _this.handleExportData(data.data);
          return data;
        }
      });
    },


    // 按照付款明细导出
    onExportDetailSearch: function onExportDetailSearch() {
      var _this2 = this;

      this.$export('付款明细导出', {
        fileHeader: this.exportDetailHeader,
        total: this.pagination.total,
        request: this.exportDetailTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _this2.handleExportData(data.data);
          data.data = _this2.handleExportDetailData(data.data);
          return data;
        }
      });
    },


    // 导出预付款冲销明细
    onExportWriteOffSearch: function onExportWriteOffSearch() {
      var _this3 = this;

      this.$export('预付款冲销明细导出', {
        fileHeader: this.exportWriteOffDetailHeader,
        total: this.pagination.total,
        request: this.exportWriteOffDetailTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _this3.handleExportData(data.data);
          data.data = _this3.handleExportWriteOffDetailData(data.data);
          return data;
        }
      });
    },


    // 导出预付款冲销状态明细
    onExportWriteOffStatus: function onExportWriteOffStatus() {
      var _this4 = this;

      this.$export('预付款单据冲销状态导出', {
        fileHeader: this.exportWriteOffStatusHeader,
        total: this.pagination.total,
        request: this.exportWriteOffStatusDataRequest,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _this4.handleExportData(data.data);
          return data;
        }
      });
    },


    // 按搜索结果汇总
    onExportSearchAggregate: function onExportSearchAggregate() {
      this.$export('付款汇总', {
        fileHeader: this.exportSearchAggregateheader,
        total: this.pagination.total,
        request: this.exportExportSearchAggregateData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _.values(data);
          return data;
        }
      });
    },


    // 批量下载 pdf zip 文件
    onDownLoadPDFS: function onDownLoadPDFS() {
      var id = this.multipleSelection.map(function (_) {
        return _.id;
      });
      request.common('exportPaymentApplicationsBatchPdfs', { id: id }).then(function (data) {
        var filename = data.data;
        var api = request.items.downloadPdfFileFromServer({ filename: filename });
        Object(__WEBPACK_IMPORTED_MODULE_2__vendor_download__["a" /* default */])(api, false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* getToken */])()
        });
      });
    },
    handleExportData: function handleExportData(data) {
      var _this5 = this;

      var payType = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.type, { 4: '批量付款' });
      data.forEach(function (row) {
        row.status = _this5.status[row.status];

        row.applicant_name = row.applicant_name + '/' + row.applicant_real_name;
        row.type = payType[row.type];

        row.payment_company = _this5.paymentCompanys[row.payment_company];
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(row.expected_date, 'yyyy-MM-dd HH:mm:ss').isValid()) {
          row.expected_date = _this5.formatExportDate(row.expected_date);
        }
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(row.paid_date, 'yyyy-MM-dd HH:mm:ss').isValid()) {
          row.paid_date = _this5.formatExportDate(row.paid_date);
        } else {
          row.paid_date = '无';
        }
      });
      return data;
    },
    formatExportDate: function formatExportDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
    },
    handleExportDetailData: function handleExportDetailData(data) {
      var _this6 = this;

      data.forEach(function (row) {
        row.detail_first_subject = _this6.originFirstSubjects[row.detail_first_subject];
        row.detail_second_subject = _this6.originSecondSubjects[row.detail_second_subject];
        row.detail_invoice_type = _this6.invoiceType[row.detail_invoice_type] || '-';
        row.detail_tax_rate = row.detail_tax_rate + '%';
        row.detail_paid_amount = filter.seperateThousandsToFixed(row.detail_paid_amount, 2);
        row.detail_paid_no_tax_amount = filter.seperateThousandsToFixed(row.detail_paid_no_tax_amount, 2);
        row.detail_apply_amount = filter.seperateThousandsToFixed(row.detail_apply_amount, 2);
        if (row.detail_project_id * 1 === 0) {
          row.detail_project_name = row.detail_project_number = '无';
        }
      });
      return data;
    },
    handleExportWriteOffDetailData: function handleExportWriteOffDetailData(data) {
      var _this7 = this;

      data.forEach(function (row) {
        row.detail_write_off_at = _this7.formatExportDate(row.detail_write_off_at);

        row.detail_first_subject = _this7.originFirstSubjects[row.detail_first_subject];
        row.detail_second_subject = _this7.originSecondSubjects[row.detail_second_subject];
        row.detail_invoice_type = _this7.invoiceType[row.detail_invoice_type] || '-';
        row.detail_tax_rate = row.detail_tax_rate + '%';
        row.detail_amount_with_taxed = filter.seperateThousandsToFixed(row.detail_amount_with_taxed, 2);
        row.detail_amount_untaxed = filter.seperateThousandsToFixed(row.detail_amount_untaxed, 2);
        if (row.detail_project_id * 1 === 0) {
          row.detail_project_name = row.detail_project_number = '无';
        }
      });
      return data;
    }
  }

});

/***/ }),

/***/ 2402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSummaryDialog_vue__ = __webpack_require__(2041);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95bd31c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSummaryDialog_vue__ = __webpack_require__(2409);
function injectStyle (ssrContext) {
  __webpack_require__(2403)
  __webpack_require__(2405)
  this["$style"] = __webpack_require__(2407)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f95bd31c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSummaryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95bd31c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSummaryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2403:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1ede6dd7", content, true, {});

/***/ }),

/***/ 2404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2405:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("30419e19", content, true, {});

/***/ }),

/***/ 2406:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1ba257a1", content, true, {});

/***/ }),

/***/ 2408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"before-close":_vm.closeDialog,"width":"50%"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"name","label":"状态","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"apply_total","label":"应付金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.apply_total,2))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"paid_total","label":"实付金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.paid_total,2))+"\n      ")]}}])})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("关闭")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_manager_rules_js__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_manager_mixins__ = __webpack_require__(4990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payment_manager_check_permission__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__payment_info_export_mixins__ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_payment_manager_components_PaymentSummaryDialog__ = __webpack_require__(2402);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PaymentSummaryDialog: __WEBPACK_IMPORTED_MODULE_9__views_payment_manager_components_PaymentSummaryDialog__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__payment_manager_mixins__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__payment_info_export_mixins__["a" /* default */]],
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_3__payment_manager_rules_js__["e" /* searchRules */],
      search: {
        applicant: null,
        type: [],
        department_id: null,
        payment_company: [],
        approve_status: [],
        payment_status: [],
        created_at: [],
        paid_date: [],
        write_off_at: [],
        write_off_status: [],
        apply_amount_min: null,
        apply_amount_max: null,
        is_urgent: null,
        id: null,
        is_from_todo_audit: false
      },
      searchFieldType: {
        is_urgent: String,
        applicant: Number,
        department_id: Number
      },
      multipleSelection: [],
      paymentCompanys: {},
      originFirstSubjects: {},
      originSecondSubjects: {},
      summaryVisible: false,
      paymentSummary: []
    };
  },

  computed: Vuex.mapState({
    type: function type(state) {
      return state.paymentManager.type;
    },
    searchApproveStatus: function searchApproveStatus(state) {
      return state.paymentManager.searchApproveStatus;
    },
    searchPaymentStatus: function searchPaymentStatus(state) {
      return state.paymentManager.searchPaymentStatus;
    },
    invoiceType: function invoiceType(state) {
      return state.paymentManager.invoiceType;
    },
    writeOffStatus: function writeOffStatus(state) {
      return state.paymentManager.writeOffStatus;
    },
    user: function user(state) {
      return state.login.user;
    }
  }),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getFinCenterConfigs();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      this.search.is_from_todo_audit = this.$route.meta.type === 'approval';
      params.is_from_todo_audit = this.search.is_from_todo_audit;
      return request.page('getPaymentManagerTable', params);
    },
    exportTableData: function exportTableData(params) {
      return request.page('exportTableData', params);
    },
    onExportRows: function onExportRows(id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportPaymentManagerData', params);
        }),
        requestParams: { id: id },
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    getFinCenterConfigs: function getFinCenterConfigs() {
      var _this2 = this;

      return request.common('getFinCenterConfigs').then(function (_ref) {
        var data = _ref.data;

        _this2.setupSubjects(data);
        _this2.setupPaymentCompany(data);
      });
    },
    setupSubjects: function setupSubjects(data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source));
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source));
    },
    setupPaymentCompany: function setupPaymentCompany(data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce(function (o, k) {
        o[k.id] = k.name;
        return o;
      }, {});
    },
    expandData: function expandData(data) {
      var result = {};
      for (var dataKey in data) {
        var tmp = data[dataKey];
        result[tmp.id] = tmp.name;
      }
      return result;
    },
    createPayment: function createPayment() {
      var _this3 = this;

      request.loading('getuserAccountDetailByUserID', { id: this.user.id }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.length) {
          _this3.$router.push('/payment-manager/create');
        } else {
          throw Error('请联系人事或管理员将您更新至员工账户列表');
        }
      }).catch(function (_) {
        _this3.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', { type: 'warning' }).then(function () {});
      });
    },
    editPayment: function editPayment(row) {
      var _this4 = this;

      request.loading('getuserAccountDetailByUserID', { id: this.user.id }).then(function (res) {
        var path = '/payment-manager/update/' + row.id;
        if (row.type * 1 === 4) {
          path = '/payment-manager/batch-update/' + row.id;
        }
        _this4.$router.push(path);
      }).catch(function (_) {
        _this4.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', { type: 'warning' }).then(function () {});
      });
    },
    createBatchPayment: function createBatchPayment() {
      var _this5 = this;

      request.loading('getuserAccountDetailByUserID', { id: this.user.id }).then(function (res) {
        _this5.$router.push('/payment-manager/bach-create');
      }).catch(function (_) {
        _this5.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', { type: 'warning' }).then(function () {});
      });
    },
    checkReviewPermission: function checkReviewPermission(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__payment_manager_check_permission__["a" /* checkReviewPermissionWithUser */])(row, this.user);
    },
    abandonPaymentApplication: function abandonPaymentApplication(id) {
      var _this6 = this;

      this.$confirm('确认放弃付款申请', '放弃付款申请', { type: 'warning' }).then(function () {
        request.common('abandonPaymentApplication', { id: id }).then(function (res) {
          _this6.$message.success('已成功放弃');
          _this6.onRefresh();
        });
      });
    },
    fetchDepartments: function fetchDepartments(name) {
      return request.common('getFinCenterDepartmentTableList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ query_all: true }, name));
    },
    getDepartmentDetail: function getDepartmentDetail(id) {
      return request.common('getFinCenterDepartmentDetail', id);
    },
    fetchOurCompanies: function fetchOurCompanies(params) {
      return request.common('getFinCenterOurCompaniesTable', params);
    },
    getOurCompaniesDetail: function getOurCompaniesDetail(id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(function (data) {
        data.data.id = String(data.data.id);
        return data;
      });
    },
    cellStyle: function cellStyle(row) {
      // 加急，且处于 待审批,财务审批,待付款,待修改 状态的条目,标红处理
      if (row.row.is_urgent && [1, 2, 3, 4, 5, 6, 7, 11, 13, 14].includes(row.row.status * 1)) {
        return 'color:red;font-weight:bold;';
      }
    },
    redirectApproveTable: function redirectApproveTable() {
      this.$router.push({ path: '/payment-manager/approval' });
    },
    isSearchItemDisplay: function isSearchItemDisplay() {
      return this.$route.meta.type === 'table';
    },
    showSummaryVisible: function showSummaryVisible() {
      var _this7 = this;

      var fields = ['pending', '5', '6', '7', 'paid', 'other', 'summary'];
      request.page('exportExportSearchAggregateData', Object(__WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__["b" /* removeEmptyParams */])(this.search)).then(function (_ref3) {
        var data = _ref3.data;

        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this7.defalutValue, data);
        _this7.paymentSummary = fields.map(function (field) {
          return data[field];
        });
        _this7.summaryVisible = true;
      });
    },
    inWriteoffStatus: function inWriteoffStatus(row) {
      return row.type === 3 && [8, 10].includes(row.status) && [1, 2].includes(row.write_off_status);
    },
    showCreateWriteOffButton: function showCreateWriteOffButton(row) {
      // 超管 或 财务管理员 或 单子发起人
      var canCreateUser = this.user.usertype === '1' || this.user.usertype === '5' || this.user.id * 1 === row.applicant;
      if (canCreateUser && row.wait_write_off > 0 && this.inWriteoffStatus(row)) {
        // 第一次 添加 冲销
        if (!row.write_off_states || !row.write_off_states.length) {
          return true;
        }
        // 第N次 添加 冲销
        if (row.write_off_states.length === 1 && row.write_off_states[0] === 8) {
          return true;
        }
      }
      return false;
    },
    showUpdateWriteOffButton: function showUpdateWriteOffButton(row) {
      // 超管 或 财务管理员 或 单子发起人
      var canEditUser = this.user.usertype === '1' || this.user.usertype === '5' || this.user.id * 1 === row.applicant;
      return canEditUser && row.write_off_states.includes(9) && this.inWriteoffStatus(row);
    },
    showReviewWriteOffButton: function showReviewWriteOffButton(row) {
      return (this.user.usertype === '1' || row.current_approver === this.user.id * 1) && row.write_off_states.some(function (item) {
        return [1, 2, 3, 4, 5].includes(item);
      }) && this.inWriteoffStatus(row);
    }
  })
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentManagerTable_vue__ = __webpack_require__(2873);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716191bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentManagerTable_vue__ = __webpack_require__(4991);
function injectStyle (ssrContext) {
  __webpack_require__(4984)
  __webpack_require__(4986)
  this["$style"] = __webpack_require__(4988)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-716191bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentManagerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716191bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentManagerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4984:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6b6ab4d8", content, true, {});

/***/ }),

/***/ 4985:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentManagerTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4986:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("71897218", content, true, {});

/***/ }),

/***/ 4987:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".header[data-v-716191bc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", "", {"version":3,"sources":["/workspace/src/views/payment-manager/pages/PaymentManagerTable.vue"],"names":[],"mappings":"AACA,yBAAyB,oBAAoB,oBAAoB,aAAa,8BAA8B,6BAA6B,uBAAuB,mBAAmB,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,6BAA6B,CAChU","file":"PaymentManagerTable.vue","sourcesContent":["\n.header[data-v-716191bc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4988:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("052469ec", content, true, {});

/***/ }),

/***/ 4989:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentManagerTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      fields: [{
        prop: 'applicant_name',
        label: '申请人',
        width: 120
      }, {
        prop: 'department_name',
        label: '部门',
        minWidth: 120,
        formatter: function formatter(row) {
          return row.department_name;
        }
      }, {
        prop: 'type',
        label: '付款类型',
        minWidth: 90,
        formatter: function formatter(row) {
          return row.type === 4 ? '批量付款' : _this.type[row.type];
        }
      }, {
        prop: 'desc',
        label: '付款说明',
        width: 100
      }, {
        prop: 'payment_company',
        label: '付款公司',
        minWidth: 90,
        formatter: function formatter(row) {
          return _this.paymentCompanys[row.payment_company];
        }
      }, {
        prop: 'apply_amount',
        label: '应付金额',
        minWidth: 90
      }, {
        prop: 'paid_amount_total',
        label: '实付金额',
        width: 153
      }, {
        prop: 'status',
        label: '付款状态',
        width: 123,
        formatter: this.formatterReviewStatus
      }, {
        prop: 'review_user_name',
        label: '当前审批人',
        width: 153,
        formatter: this.formatterReviewUserName
      }, {
        prop: 'created_at',
        label: '申请日期',
        width: 160
      }, {
        prop: 'paid_date',
        label: '付款日期',
        width: 153,
        formatter: this.formatterPaidDate
      }, {
        prop: 'updated_at',
        label: '更新日期',
        width: 160
      }, {
        prop: 'write_off_status',
        label: '冲销状态',
        width: 80,
        formatter: this.formatterWriteOffStatus
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    type: function type(state) {
      return state.paymentManager.type;
    },
    status: function status(state) {
      return state.paymentManager.status;
    },
    writeOffStatus: function writeOffStatus(state) {
      return state.paymentManager.writeOffStatus;
    }
  })),
  methods: {
    formatterReviewStatus: function formatterReviewStatus(row) {
      return this.status[row.status] || '-';
    },
    formatterReviewUserName: function formatterReviewUserName(row) {
      if (row.status === 1) {
        return row.first_approver_name;
      } else if (row.status === 2) {
        return row.second_approver_name;
      } else if (row.status === 3) {
        return row.third_approver_name;
      } else if (row.status === 4) {
        return row.fourth_approver_name;
      } else if (row.status === 5) {
        return '费用会计';
      } else if (row.status === 6) {
        return '财务经理';
      } else if (row.status === 13) {
        return row.department_approver_name;
      } else if (row.status === 14) {
        return row.special_approver_name;
      }
      return '-';
    },
    formatterPaidDate: function formatterPaidDate(row) {
      if (row.paid_date !== '0000-00-00 00:00:00') {
        return row.paid_date.substr(0, 10);
      }
      return '-';
    },
    formatterWriteOffStatus: function formatterWriteOffStatus(row) {
      if (row.type !== 3 || ![8, 10].includes(row.status)) {
        return '-';
      }
      for (var key in this.writeOffStatus) {
        if (key * 1 === row.write_off_status * 1 && Object.hasOwnProperty.call(this.writeOffStatus, key)) {
          return this.writeOffStatus[key];
        }
      }
      return '-';
    }
  }
});

/***/ }),

/***/ 4991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading header"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("付款管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"申请人","prop":"applicant"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入申请人名称，仅显示活跃状态的管理员","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1,2,3,5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.applicant),callback:function ($$v) {_vm.$set(_vm.search, "applicant", $$v)},expression:"search.applicant"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"部门","prop":"department_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入部门名称","query-request":_vm.fetchDepartments,"find-request":_vm.getDepartmentDetail},model:{value:(_vm.search.department_id),callback:function ($$v) {_vm.$set(_vm.search, "department_id", $$v)},expression:"search.department_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"付款类型","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.type),callback:function ($$v) {_vm.$set(_vm.search, "type", $$v)},expression:"search.type"}},_vm._l((Object.assign({}, _vm.type, {4: '批量付款'})),function(label,key){return _c('el-option',{key:key,attrs:{"label":label,"value":key}})}),1)],1),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"审批状态","prop":"approve_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","clearable":""},model:{value:(_vm.search.approve_status),callback:function ($$v) {_vm.$set(_vm.search, "approve_status", $$v)},expression:"search.approve_status"}},_vm._l((_vm.searchApproveStatus),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"付款状态","prop":"payment_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.payment_status),callback:function ($$v) {_vm.$set(_vm.search, "payment_status", $$v)},expression:"search.payment_status"}},_vm._l((_vm.searchPaymentStatus),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"申请日期","prop":"created_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"付款日期","prop":"paid_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.paid_date),callback:function ($$v) {_vm.$set(_vm.search, "paid_date", $$v)},expression:"search.paid_date"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"应付金额"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"apply_amount_min"}},[_c('el-input',{attrs:{"placeholder":"请输入应付金额起始值"},model:{value:(_vm.search.apply_amount_min),callback:function ($$v) {_vm.$set(_vm.search, "apply_amount_min", $$v)},expression:"search.apply_amount_min"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('p',{staticStyle:{"padding":"0","margin":"0","text-align":"center"}},[_vm._v("至")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"apply_amount_max"}},[_c('el-input',{attrs:{"placeholder":"请输入应付金额起始值"},model:{value:(_vm.search.apply_amount_max),callback:function ($$v) {_vm.$set(_vm.search, "apply_amount_max", $$v)},expression:"search.apply_amount_max"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否加急","prop":"is_urgent"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.is_urgent),callback:function ($$v) {_vm.$set(_vm.search, "is_urgent", $$v)},expression:"search.is_urgent"}},_vm._l(({1: '是', 0: '否'}),function(label,key){return _c('el-option',{key:key,attrs:{"label":label,"value":key}})}),1)],1),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"付款ID","prop":"id"}},[_c('el-input',{attrs:{"placeholder":"请输入付款ID"},model:{value:(_vm.search.id),callback:function ($$v) {_vm.$set(_vm.search, "id", $$v)},expression:"search.id"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"冲销时间","prop":"write_off_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.write_off_at),callback:function ($$v) {_vm.$set(_vm.search, "write_off_at", $$v)},expression:"search.write_off_at"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"冲销状态","prop":"write_off_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.write_off_status),callback:function ($$v) {_vm.$set(_vm.search, "write_off_status", $$v)},expression:"search.write_off_status"}},_vm._l((_vm.writeOffStatus),function(label,key){return _c('el-option',{key:key,attrs:{"label":label,"value":key}})}),1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"付款公司","prop":"payment_company"}},[_c('remote-select',{staticClass:"width-max",attrs:{"multiple":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"仅支持搜索启用中的付款公司,可输入名称进行搜索","query-request":function (_){ return _vm.fetchOurCompanies(Object.assign(_, {is_disabled: 0})); },"find-request":_vm.getOurCompaniesDetail},model:{value:(_vm.search.payment_company),callback:function ($$v) {_vm.$set(_vm.search, "payment_company", $$v)},expression:"search.payment_company"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"},on:{"click":_vm.createPayment}},[_vm._v("发起付款申请\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"},on:{"click":_vm.createBatchPayment}},[_vm._v("人事批量付款申请\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":_vm.onExportDetailSearch}},[_vm._v("导出付款明细\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":_vm.onExportWriteOffSearch}},[_vm._v("导出预付款冲销明细\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":_vm.onExportWriteOffStatus}},[_vm._v("导出预付款冲销状态明细\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showSummaryVisible}},[_vm._v("按搜索结果汇总\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-pdf","disabled":!_vm.multipleSelection.length,"size":"small"},on:{"click":_vm.onDownLoadPDFS}},[_vm._v("批量生成PDF\n      ")]),_vm._v(" "),(_vm.$route.meta.type !== 'approval')?_c('el-button',{staticStyle:{"float":"right"},attrs:{"type":"success","size":"small"},on:{"click":_vm.redirectApproveTable}},[_vm._v("查看待审批\n      ")]):_vm._e()],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":"","cell-style":_vm.cellStyle},on:{"selection-change":function (val) { return this$1.multipleSelection = val; }}},[_c('el-table-column',{attrs:{"type":"selection","width":"40"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ID","width":"70"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/payment-manager/detail/" + (scope.row.id))}},[_c('span',{attrs:{"size":"mini"}},[_vm._v(_vm._s(scope.row.id))])])]}}])}),_vm._v(" "),_vm._l((_vm.fields),function(attr,index){return [_c('el-table-column',_vm._b({key:index},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"button-gutter"},[_c('button-gutter',[_c('router-link',{attrs:{"to":("/payment-manager/detail/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"success"}},[_vm._v("查看")])],1),_vm._v(" "),(_vm.showCreateWriteOffButton(scope.row))?_c('router-link',{attrs:{"to":("/payment-manager/write-off/create/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"warning"}},[_vm._v("冲销-申请")])],1):_vm._e(),_vm._v(" "),(_vm.showUpdateWriteOffButton(scope.row))?_c('router-link',{attrs:{"to":("/payment-manager/write-off/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"danger"}},[_vm._v("冲销-修改")])],1):_vm._e(),_vm._v(" "),(_vm.showReviewWriteOffButton(scope.row))?_c('router-link',{attrs:{"to":("/payment-manager/write-off/review/" + (scope.row.id))}},[_c('el-button',{attrs:{"size":"mini","type":"warning"}},[_vm._v("冲销-审批")])],1):_vm._e(),_vm._v(" "),(_vm.checkReviewPermission(scope.row))?_c('router-link',{attrs:{"to":"/payment-manager/review/" + (scope.row.id) + "?from=" + _vm.$route.meta.type}},[_c('el-button',{attrs:{"size":"mini","type":"warning"}},[_vm._v("审批\n                ")])],1):_vm._e()],1),_vm._v(" "),([13, 11].includes(scope.row.status) && scope.row.applicant * 1 === _vm.user.id * 1)?_c('button-gutter',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.editPayment(scope.row)}}},[_vm._v("修改\n              ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.abandonPaymentApplication(scope.row.id)}}},[_vm._v("放弃\n              ")])],1):_vm._e()],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('payment-summary-dialog',{attrs:{"title":"付款汇总","visible":_vm.summaryVisible,"data":_vm.paymentSummary},on:{"closeDialog":function($event){_vm.summaryVisible = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/payment-manager-table.e85c03a01660bfdf77ae.js